module.exports = __webpack_public_path__ + "static/media/2.1f211e52.webp";